import React from "react";
import { Link } from "react-router-dom";

/**
 * Every category, with the current one highlighted. Sticky in the left column
 * on desktop; below 1024px it becomes one horizontally scrolling row and drops
 * its "Semua kategori" label (spec section 5). The row scrolls inside itself,
 * never the page.
 */
const CategoryRail = ({ categories, activeSlug }) => (
  <nav className="hc-rail" aria-label="Semua kategori">
    <span className="hc-rail__label">Semua kategori</span>
    {categories.map(category => {
      const isActive = category.slug === activeSlug;

      return (
        <Link
          key={category.slug}
          to={`/${category.slug}`}
          className={`hc-rail__item${isActive ? " hc-rail__item--active" : ""}`}
          aria-current={isActive ? "page" : undefined}
        >
          <span className="hc-rail__name">{category.title}</span>
          <span className="hc-rail__n">{category.articles.length}</span>
        </Link>
      );
    })}
  </nav>
);

export default CategoryRail;
